import { render, staticRenderFns } from "./CampaignCreativesListChartComponent.vue?vue&type=template&id=6071bff2&"
import script from "./CampaignCreativesListChartComponent.vue?vue&type=script&lang=js&"
export * from "./CampaignCreativesListChartComponent.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCreativesListChartComponent.vue?vue&type=style&index=0&id=6071bff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports